import PropTypes from 'prop-types'
import { useTranslation } from '@mc/i18n'

const ThankYou = ({ descriptionText }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='mc-text--center mc-animation--show mc-animation--animating'>
      <h2 className='mc-text-h4'>
        {t('emailCaptureBanner.form.success.header')}
      </h2>
      <p className='mc-mt-2 mc-opacity--muted'>
        {descriptionText || t('emailCaptureBanner.form.success.description')}
      </p>
    </div>
  )
}

ThankYou.propTypes = {
  descriptionText: PropTypes.string,
}

export default ThankYou
